module.exports = __webpack_public_path__ + "static/media/something_went_wrong.262d28c5.png";